export const OFFLINE = 'OFFLINE';
export const NO_DATA = 'NO_DATA';
export const ENTER_CODE = 'ENTER_CODE';
export const SEND_CODE_BY_CHANNEL = 'SEND_CODE_BY_CHANNEL';
export const ENTER_EMAIL = 'ENTER_EMAIL';
export const SNIPER_LINK = 'SNIPER_LINK';
